import { getBundleResources, mapActorResource } from "./fhir.utils";
import {
  ActorModel,
  FhirClientPort,
  PractitionerResource,
} from "./fhir.types";

export class PractitionerService {
  constructor(private readonly client: FhirClientPort) {}

  async searchByEmail(email: string): Promise<ActorModel[]> {
    const bundle = await this.client.search("Practitioner", {
      email: email.trim(),
      active: true,
      _count: 100,
    });

    return getBundleResources<PractitionerResource>(
      bundle,
      "Practitioner",
    ).map(mapActorResource);
  }

  async searchByName(query: string): Promise<ActorModel[]> {
    const normalized = query.trim();
    const bundle = await this.client.search("Practitioner", {
      ...(normalized ? { name: normalized } : {}),
      active: true,
      _count: 100,
    });

    return getBundleResources<PractitionerResource>(
      bundle,
      "Practitioner",
    ).map(mapActorResource);
  }
}
